var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.moneyFormat = Shopify.moneyFormat || "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.moneyFormat;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

Shopify.setCookie = function (cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

Shopify.getCookie = function (cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

function dispatchWindowEvent(eventName) {
  const event = new Event(eventName);
  window.dispatchEvent(event);
}

function dispatchDocumentEvent(eventName) {
  const event = new Event(eventName);
  document.dispatchEvent(event);
}

function triggerCartUpdate() {
  dispatchDocumentEvent("cartUpdated");
}

function triggerAutoVariantChanged(id, qty) {
  const event = new CustomEvent("autoVariantChanged", {
    detail: {
      id: id,
      qty: qty,
    },
  });
  document.dispatchEvent(event);
}

// alpine js global store management:
document.addEventListener("alpine:init", () => {
  Alpine.store("state", {
    init() {
      this.getCart("alphineCartInit");
    },
    cart: {},
    updateCart() {
      this.getCart("alphineCartUpdated");
    },
    getCart(eventName) {
      axios.get("/cart.js").then((response) => {
        this.cart = response.data;

        // add additional properties:
        this.cart.items = this.cart.items.map((item) => {
          item = {
            ...item,
            _is_option_variant: false,
            _option_main_variant: "",
            _option_main_product: "",
            _is_nala_tier: false,
            _is_uom_variant: false,
            _is_nala_auto: false,
            _uom_qty: 0,
          };

          if (item.properties) {
            for (prop in item.properties) {
              if (prop === "_nala_option_variant") {
                item._is_option_variant = true;
                item._is_nala_auto = true;
              } else if (prop === "_nala_option_main_variant") {
                item._option_main_variant = item.properties[prop].toString();
              } else if (prop === "_nala_option_main_product") {
                item._option_main_product = item.properties[prop].toString();
              } else if (prop === "_nala_tier") {
                item._is_nala_tier = true;
              } else if (prop === "Pack Size" || prop === "UOM") {
                item._is_uom_variant = true;
              } else if (prop === "_nala_auto") {
                item._is_nala_auto = true;
              } else if (prop === "_nala_uom_qty") {
                item._uom_qty = item.properties[prop];
              }
            }
          }

          return item;
        });
        dispatchDocumentEvent(eventName);
      });
    },
    isEmptyCart() {
      let _isEmpty = true;

      if (this.cart.item_count) {
        _isEmpty = false;
      }

      return _isEmpty;
    },
  });

  Alpine.data("breadcrumbsApp", function () {
    return {
      shop: this.$persist(false),
      setShopBreadcrumbsItem(url) {
        const _is_shop_page = url.indexOf("/pages/shop") >= 0;
        const _is_product_or_category_page =
          url.indexOf("/collections") >= 0 || url.indexOf("/products") >= 0;

        if (_is_shop_page || _is_product_or_category_page) {
          this.shop = true;
        } else {
          this.shop = false;
        }
      },
    };
  });
});

// universal method to update the product option main variant (e.g. anodization)
async function addOptionMainVariant() {
  const cartItems = Alpine.store("state").cart.items;

  let mainOptionVariants = {};
  cartItems.forEach((item) => {
    mainOptionVariants[item._option_main_variant] = item._option_main_product;
  });

  const mainOptionVariantKeys = Object.keys(mainOptionVariants);
  for(let i=0; i<mainOptionVariantKeys.length; i++) {
    const mainOptionVariant = mainOptionVariantKeys[i];
    if (mainOptionVariant == "") {
      continue;
    }
    const mainOptionProduct = mainOptionVariants[mainOptionVariant];
    const { data: mainOptionProductData } = await axios.get(`/products/${mainOptionProduct}.js`);
    const sellingPlans = {};
    mainOptionProductData.selling_plan_groups.forEach((group) => {
      group.selling_plans.forEach((plan) => {
        sellingPlans[plan.name] = plan.id.toString();
      });
    });

    const _current_qty = {};
    const isOptionUpdate = {};
    const keys = {};
    const updateKey = {};

    // get main option varaint details if added to cart
    const currentOption = cartItems.filter(
      (item) => item.variant_id == mainOptionVariant
    );
    currentOption.forEach((item) => {
      const sellingPlan = item?.selling_plan_allocation?.selling_plan;
      let key = "NA";
      if (sellingPlan && sellingPlans[sellingPlan.name]) {
        key = sellingPlan.name;
      }
      _current_qty[key] = item.quantity;
      isOptionUpdate[key] = true;
      updateKey[key] = item.key;
      keys[key] = true;
    })

    //get the option variant quantity required to add automatically
    const _qty = {};
    cartItems.forEach((item) => {
      if (item._option_main_variant == mainOptionVariant) {
        const sellingPlan = item?.selling_plan_allocation?.selling_plan;
        let key = "NA";
        if (sellingPlan && sellingPlans[sellingPlan.name]) {
          key = sellingPlan.name;
        }
        if (!_qty[key]) {
          _qty[key] = 0;
        }
        _qty[key] += item.quantity;
        keys[key] = true;
      }
    });

    Object.keys(keys).forEach((key) => {
      if (!_qty[key]) {
        _qty[key] = 0;
      }
      if (!_current_qty[key]) {
        _current_qty[key] = 0;
      }
      //proceed only if the quantities don't match
      if (_qty[key] !== _current_qty[key]) {
        if (isOptionUpdate[key]) {
          //update the existing cart option variant
          updates = {
            id: updateKey[key],
            quantity: _qty[key],
            selling_plan: sellingPlans[key]??""
          };
  
          axios
            .post("/cart/change.js", updates)
            .then((response) => {
              triggerCartUpdate();
              triggerAutoVariantChanged(updateKey[key].replace(`${mainOptionVariant}:`, ""), _qty[key]);
            })
            .catch((e) => {
              console.log("e", e);
            });
        } else {
          //create new cart option variant
          let items = [
            {
              id: mainOptionVariant.toString(),
              quantity: _qty[key],
              selling_plan: sellingPlans[key]??"",
              properties: {
                _nala_option_variant: mainOptionVariant,
                _nala_auto: true,
              },
            },
          ];
  
          data = {
            items,
          };
          axios
            .post("/cart/add.js", data)
            .then((response) => {
              triggerCartUpdate();
            })
            .catch((e) => {
              if(e.response.status === 500) {
                triggerCartUpdate();
              }
              console.log("e", e);
            });
        }
      }
    });
  };

  // delete the current options if not exists in the mainOptionVariants list
  const currentOptions = cartItems.filter(
    (item) =>
      item._is_option_variant == true &&
      !mainOptionVariants[item.id]
  );
  currentOptions.forEach((item) => {
    updates = {
      id: item.key,
      quantity: 0,
    };

    axios
      .post("/cart/change.js", updates)
      .then((response) => {
        triggerCartUpdate();
        triggerAutoVariantChanged(item.key.replace(`${item.id}:`, ""), 0);
      })
      .catch((e) => {
        console.log("e", e);
      });
  });
}

document.addEventListener("cartUpdated", () => {
  Alpine.store("state").updateCart();
});

document.addEventListener("alphineCartUpdated", () => {
  addOptionMainVariant();
});
